import React from 'react';

import { css } from '@emotion/css';
import { theme } from 'theme';

import { Button } from 'components/Button';
import { FlexSpace } from 'components/FlexSpace';

import { KeyboardShortcut } from './KeyboardShortcut';

export type KeyboardShortcutButtonProps = {
  variant?: 'primary' | 'secondary';
  label: string;
  shortcut: string;
  onClick: () => void;
  disabled?: boolean;
};

export const KeyboardShortcutButton = ({
  variant = 'primary',
  label,
  shortcut,
  onClick,
  disabled,
}: KeyboardShortcutButtonProps) => (
  <Button
    className={css`
      padding: 0px;
      padding-left: 7px;
      padding-right: 7px;
      border-radius: 8px;
      border: 1px solid black;
      background-color: ${variant === 'primary' ? theme.colors.primary[600] : 'white'};
      color: ${variant === 'primary' ? theme.colors.neutral[0] : theme.colors.neutral[600]};
    `}
    onClick={onClick}
    type={variant === 'primary' ? 'primary' : 'default'}
    size="small"
    disabled={disabled}
  >
    <FlexSpace direction="row" gap={8}>
      {label}
      <KeyboardShortcut shortcut={shortcut} onClick={() => !disabled && onClick()} />
    </FlexSpace>
  </Button>
);
